import React from 'react';
import AppFormInput from "../../../components/ui/AppFormInput";

const BeneficiaryDialog = ({
    visible,
    onClose,
    isEditMode,
    formData,
    setFormData,
    formErrors,
    submitting,
    onSubmit
}) => {
    return (
        <dialog className={`modal ${visible ? 'modal-open' : ''}`}>
            <div className="modal-box bg-white text-slate-800 max-w-4xl w-full rounded-2xl shadow-sm">
                <h3 className="font-bold text-lg mb-6 text-[#135A9C]">
                    {isEditMode ? "Edit Beneficiary Details" : "Add New Beneficiary"}
                </h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-control w-full space-y-1">
                        <label htmlFor="title" className="label-text text-xs font-bold text-slate-700">Title *</label>
                        <select
                            id="title"
                            className={`select select-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] focus:ring-2 focus:ring-[#135A9C]/20 text-sm ${formErrors.title ? 'select-error' : ''}`}
                            value={formData.title}
                            onChange={(e) => setFormData({...formData, title: e.target.value})}
                        >
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Miss">Miss</option>
                            <option value="Dr">Dr</option>
                            <option value="Prof">Prof</option>
                        </select>
                        {formErrors.title && <p className="text-error text-xs mt-1">{formErrors.title}</p>}
                    </div>

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="First Name *"
                        id="firstName"
                        type="text"
                        value={formData.firstName}
                        onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                        error={formErrors.firstName}
                    />

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="Last Name *"
                        id="lastName"
                        type="text"
                        value={formData.lastName}
                        onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                        error={formErrors.lastName}
                    />

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="ID Number *"
                        id="idNumber"
                        type="text"
                        value={formData.idNumber}
                        onChange={(e) => setFormData({...formData, idNumber: e.target.value})}
                        error={formErrors.idNumber}
                    />

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="Passport Number"
                        id="passportNumber"
                        type="text"
                        value={formData.passportNumber}
                        onChange={(e) => setFormData({...formData, passportNumber: e.target.value})}
                    />

                    <div className="form-control w-full space-y-1">
                        <label htmlFor="gender" className="label-text text-xs font-bold text-slate-700">Gender *</label>
                        <select
                            id="gender"
                            className={`select select-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] focus:ring-2 focus:ring-[#135A9C]/20 text-sm ${formErrors.gender ? 'select-error' : ''}`}
                            value={formData.gender}
                            onChange={(e) => setFormData({...formData, gender: e.target.value})}
                        >
                            <option value="MALE">MALE</option>
                            <option value="FEMALE">FEMALE</option>
                        </select>
                        {formErrors.gender && <p className="text-error text-xs mt-1">{formErrors.gender}</p>}
                    </div>

                    <div className="form-control w-full space-y-1">
                        <label htmlFor="relationship" className="label-text text-xs font-bold text-slate-700">Relationship *</label>
                        <select
                            id="relationship"
                            className={`select select-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] focus:ring-2 focus:ring-[#135A9C]/20 text-sm ${formErrors.relationship ? 'select-error' : ''}`}
                            value={formData.relationship}
                            disabled={isEditMode}
                            onChange={(e) => setFormData({...formData, relationship: e.target.value})}
                        >
                            <option value="CHILD">CHILD</option>
                            <option value="SPOUSE">SPOUSE</option>
                            <option value="FAMILY_MEMBER">FAMILY MEMBER</option>
                            <option value="BENEFICIARY">BENEFICIARY</option>
                        </select>
                        {formErrors.relationship && <p className="text-error text-xs mt-1">{formErrors.relationship}</p>}
                    </div>

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="Date of Birth *"
                        id="dateOfBirth"
                        type="date"
                        value={formData.dateOfBirth}
                        onChange={(e) => setFormData({...formData, dateOfBirth: e.target.value})}
                        error={formErrors.dateOfBirth}
                    />

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="Email Address"
                        id="emailAddress"
                        type="email"
                        value={formData.emailAddress}
                        onChange={(e) => setFormData({...formData, emailAddress: e.target.value})}
                    />

                    <AppFormInput containerClassName="form-control w-full space-y-1"
                        label="Phone Number"
                        id="phoneNumber"
                        type="tel"
                        value={formData.phoneNumber}
                        onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
                    />

                    <div className="form-control w-full space-y-1 md:col-span-2">
                        <label htmlFor="reason" className="label-text text-xs font-bold text-slate-700">Reason for Change *</label>
                        <textarea
                            id="reason"
                            rows={3}
                            className={`textarea textarea-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] focus:ring-2 focus:ring-[#135A9C]/20 text-sm ${formErrors.reason ? 'textarea-error' : ''}`}
                            placeholder="Please provide a reason for this change request"
                            value={formData.reason}
                            onChange={(e) => setFormData({...formData, reason: e.target.value})}
                        />
                        {formErrors.reason && <p className="text-error text-xs mt-1">{formErrors.reason}</p>}
                    </div>
                </div>
                
                <div className="modal-action mt-6 border-t border-slate-100 pt-4">
                    <button 
                        type="button" 
                        className="btn btn-ghost text-slate-500 rounded-xl px-6" 
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button 
                        type="button" 
                        className="btn bg-[#135A9C] hover:bg-[#0e4475] text-white border-none rounded-xl px-8" 
                        onClick={onSubmit} 
                        disabled={submitting}
                    >
                        {submitting ? "Submitting..." : "Submit"}
                    </button>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button" onClick={onClose}>close</button>
            </form>
        </dialog>
    );
};

export default BeneficiaryDialog;
